import React, { useEffect } from "react";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";

import {
  DISPLAY_MAIN_PAYMENT_ERROR,
  HIDE_LOADING
} from "@constants/actionTypes";
import {
  placePayPalSellOrder,
  updatePayPalSellOrder
} from "@actions/paypalSell";
import { getFormSyncErrors } from "redux-form";
import { withRouter } from "react-router-dom";

const PayPalSellButton = ({
  payPalSellErrors,
  displayMainError,
  hideLoading,
  placePayPalSellOrder,
  paypalButtonClass,
  config,
  updatePayPalSellOrder,
  history
}) => {
  useEffect(() => {
    renderButton();
  }, []);

  const onCancel = () => {
    hideLoading();
  };

  const onError = e => {
    if (
      e ===
      "updatePayPalSellOrder: Error: Please re-enter your credit card information and try again."
    ) {
      displayMainError(e.replace("updatePayPalSellOrder: Error: ", ""));
    } else if (!Object.keys(payPalSellErrors).length) {
      displayMainError(
        "There was a problem checking out with PayPal. Please try another payment method or contact customer service."
      );
    }
    hideLoading();
  };

  const onPayment = async () => {
    // This returns the paypal id.
    return await placePayPalSellOrder();
  };

  const payment = async (resolve, reject) => {
    try {
      const paymentId = await onPayment();
      resolve(paymentId);
    } catch (error) {
      reject();
    }
  };

  const onAuthorize = async data => {
    const ctx = {
      props: {
        history
      }
    };

    await updatePayPalSellOrder(data.paymentID, data.payerID, ctx);
  };

  const renderButton = () => {
    global.paypal.Button.render(renderOptions(), `.${paypalButtonClass}`);
  };

  const renderOptions = () => {
    const env = config.devMode === "production" ? "production" : "sandbox";
    const client = {
      sandbox:
        "AWpcWnSknfcPAnkpel5M8kqGJp5gCJQbGH-CkOYF5Qy78FBTfNQhb8CN9z95U4wqHKur-o0QrBQB7P3B",
      production: "AdNrKxBub5b7vLSpYTmOtj0XchDNwSs_nR2SoX3JNS7iSoSnZoGcEC9hmeaL"
    };

    return {
      env,
      client,
      payment: payment,
      onAuthorize: onAuthorize,
      onError: onError,
      onCancel: onCancel,
      style: {
        size: "responsive",
        color: "gold",
        label: "paypal",
        height: 40,
        tagline: false
      }
    };
  };

  return <div className={paypalButtonClass} />;
};

export default withRouter(
  connect(
    state => ({
      config: state.config,
      payPalSellErrors: getFormSyncErrors("payPalSell")(state)
    }),
    dispatch => ({
      displayMainError: message =>
        dispatch(defaultAction(DISPLAY_MAIN_PAYMENT_ERROR, message)),
      placePayPalSellOrder: () => dispatch(placePayPalSellOrder()),
      updatePayPalSellOrder: (paymentID, payerID, ctx) =>
        dispatch(updatePayPalSellOrder(paymentID, payerID, ctx)),
      hideLoading: () => dispatch(defaultAction(HIDE_LOADING))
    })
  )(PayPalSellButton)
);
